import { ProductCardType } from '../product-list/use-product-list-settings'
import TakebackGalleryCard from './takeback-gallery-card'
import TakebackExtendedCard from './takeback-extended-card'
import TakebackCategoryBannerCard from './takeback-category-banner-card'
import TakebackCheckoutCard from './takeback-checkout-card'
import { useResponsive } from 'packages/microsite-components/src/hooks'

type Props = {
  listType?: ProductCardType | undefined
  categoryId?: string | undefined
}

export default function TakebackWrapper({ listType, categoryId }: Props) {
  const { breakpoints } = useResponsive()

  if (categoryId) {
    if (!listType) {
      return <TakebackCategoryBannerCard breakpoints={breakpoints} />
    }
    if (listType === 'gallery' || (breakpoints.min.SM && breakpoints.max.LG)) {
      return <TakebackGalleryCard />
    }
    return <TakebackExtendedCard breakpoints={breakpoints} />
  }

  if (!listType) {
    return <TakebackCheckoutCard breakpoints={breakpoints} />
  }
}
